const widths = {
    small: '1280px',
    medium: '1920px',
};

const heights = {
    small: '720px',
    medium: '1080px',
};

const devices = {
    small: `(max-width: ${widths.small}), (max-height: ${heights.small})`,
    medium: `(max-width: ${widths.medium}), (max-height: ${heights.medium})`,
};

export default devices;
